<!-- GoodsSwipe.vue -->
<template>
	<div class="swipe-wrapper ui-common-swiper" v-if="detailInfo">
		<!-- 轮播图 -->
		<mt-swipe
				:auto="0"
				class="ui-common-swiper"
				:prevent="false"
				:stop-propagation="true"
				@change="handleChange"
		>
			<mt-swipe-item
					v-for="(item, index) in detailInfo.photos"
					v-bind:key="index"
					v-if="detailInfo.photos && detailInfo.photos.length > 0"
			>
				<video
						v-if="matchType(item) == 'video'"
						v-bind:src="item"
						ref="video"
						webkit-playsinline="true"
						playsinline="true"
						x-webkit-airplay="true"
						x5-video-player-type="h5"
						x5-video-player-fullscreen="true"
						x5-video-orientation="portraint"
						style="object-fit:fill"
						preload="auto"
						controls
						controlslist="nodownload"
						muted="true"
						@waiting="handleWaiting"
						@canplaythrough="state.isLoading = false"
						@playing="state.isLoading = false, state.controlBtnShow = false, state.playing=true"
						@stalled="state.isLoading = true"
				>您的浏览器不支持HTML5</video>
				<img v-else v-bind:src="item" v-on:click="setPopupVisible(index)" />

			</mt-swipe-item>
			<mt-swipe-item v-if="!detailInfo.photos || detailInfo.photos.length <= 0">
				<img
						src="../../../../assets/image/home/default_image_banner.png"
						class="product-img"
				/>
			</mt-swipe-item>
		</mt-swipe>

	</div>
</template>

<script>
	import PreviewPicture from './PreviewPicture'
	import { mapState, mapMutations } from 'vuex'
	export default {
		data () {
			return {
				popupVisible: false,
				index: 0
			}
		},

		components: {
			'v-picture': PreviewPicture
		},

		created () {
			this.$on('hide-priview-picture', value => {
				this.popupVisible = value
				this.setisPreviewPicture(value)
			})
		},

		computed: {
			...mapState({
				detailInfo: state => state.goodsdetail.detailInfo
			})
		},

		methods: {
			...mapMutations({
				setisPreviewPicture: 'setisPreviewPicture',
				setSwiperId: 'setSwiperId'
			}),

			setPopupVisible () {
				this.popupVisible = true
				this.setisPreviewPicture(true)
			},
			matchType(fileName) {
				// 后缀获取
				var suffix = '';
				// 获取类型结果
				var result = '';
				try {
					var flieArr = fileName.split('.');
					suffix = flieArr[flieArr.length - 1];
				} catch (err) {
					suffix = '';
				}
				// fileName无后缀返回 false
				if (!suffix) {
					result = false;
					return result;
				}
				// 图片格式
				var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
				// 进行图片匹配
				result = imglist.some(function (item) {
					return item == suffix;
				});
				if (result) {
					result = 'image';
					return result;
				};
				// 匹配txt
				var txtlist = ['txt'];
				result = txtlist.some(function (item) {
					return item == suffix;
				});
				if (result) {
					result = 'txt';
					return result;
				};
				// 匹配 excel
				var excelist = ['xls', 'xlsx'];
				result = excelist.some(function (item) {
					return item == suffix;
				});
				if (result) {
					result = 'excel';
					return result;
				};
				// 匹配 word
				var wordlist = ['doc', 'docx'];
				result = wordlist.some(function (item) {
					return item == suffix;
				});
				if (result) {
					result = 'word';
					return result;
				};
				// 匹配 pdf
				var pdflist = ['pdf'];
				result = pdflist.some(function (item) {
					return item == suffix;
				});
				if (result) {
					result = 'pdf';
					return result;
				};
				// 匹配 ppt
				var pptlist = ['ppt'];
				result = pptlist.some(function (item) {
					return item == suffix;
				});
				if (result) {
					result = 'ppt';
					return result;
				};
				// 匹配 视频
				var videolist = ['mp4', 'm2v', 'mkv'];
				result = videolist.some(function (item) {
					return item == suffix;
				});
				if (result) {
					result = 'video';
					return result;
				};
				// 匹配 音频
				var radiolist = ['mp3', 'wav', 'wmv'];
				result = radiolist.some(function (item) {
					return item == suffix;
				});
				if (result) {
					result = 'radio';
					return result;
				}
				// 其他 文件类型
				result = 'other';
				return result;
			},
			handleChange (index) {
				this.index = index
				this.setSwiperId(index)
				if(this.detailInfo.photos.length == ( index + 1 ) ) {

				}
			}
		}
	}
</script>

<style lang="scss">
	video{width: 100%;
		height: 100%;}
	.ui-common-swiper {
		width: 100%;
		height: 15rem !important;
		.mint-swipe-items-wrap {
			.mint-swipe-item {
				text-align: center;
				overflow: hidden;
				img {
					width: 100%;
					height: auto;
				}
			}
		}
		.mint-swipe-indicators {
			div.mint-swipe-indicator {
				background: #efeff4;
				opacity: 1;
				&.is-active {
					background: $primaryColor;
				}
			}
		}
	}
</style>
